<template>
  <div class="terms-page">
    <div class="nav">
      <div class="logo">
        <router-link to="/">
          <img src="../assets/logo-l.png" alt="Nvoko Logo" />
        </router-link>
      </div>
    </div>

    <div class="terms-container">
      <div class="terms-content">
        <div v-html="html" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TermsOfUse",
  data() {
    return {
      html: "Okay"
    };
  },
  async created() {
    const html = await axios.get("/html/TermsOfUse.html");
    this.html = html.data;
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_mixins.scss";

.terms-page {
  background: linear-gradient(
    to bottom right,
    rgba(0, 0, 0, 0.95),
    rgba(20, 20, 20, 0.9)
  );
  min-height: 100vh;
  width: 100%;
  position: relative;
  color: white;
  overflow-x: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("/path-to-your-texture.png") repeat;
    opacity: 0.03;
    pointer-events: none;
  }

  .nav {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 15%;
    padding-top: 30px;
    position: relative;
    z-index: 1;

    .logo {
      padding: 7px;
      justify-content: flex-start;
      align-items: flex-start;
      display: flex;
    }
  }

  .terms-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: calc(100vh - 120px);
    padding: 40px 15%;
    position: relative;
    z-index: 1;

    .terms-content {
      background: linear-gradient(
        145deg,
        rgba(40, 40, 40, 0.6),
        rgba(20, 20, 20, 0.8)
      );
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      border-radius: 24px;
      padding: 60px;
      width: 100%;
      max-width: 1200px;
      box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3),
        0 1px 1px rgba(255, 255, 255, 0.05) inset;
      border: 1px solid rgba(255, 255, 255, 0.05);

      :deep(h1),
      :deep(h2),
      :deep(h3) {
        color: $white;
        margin-bottom: 24px;
        font-weight: 600;
        letter-spacing: -0.02em;
      }

      :deep(h1) {
        font-size: 2.5rem;
        background: linear-gradient(to right, #ffffff, #e0e0e0);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-bottom: 40px;
      }

      :deep(h2) {
        font-size: 1.8rem;
        color: #f0f0f0;
        margin-top: 40px;
      }

      :deep(h3) {
        font-size: 1.4rem;
        color: #e0e0e0;
        margin-top: 30px;
      }

      :deep(p) {
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.7;
        margin-bottom: 20px;
        font-size: 1.1rem;
      }

      :deep(ul),
      :deep(ol) {
        margin-bottom: 20px;
        padding-left: 24px;
        color: rgba(255, 255, 255, 0.8);
      }

      :deep(li) {
        margin-bottom: 12px;
        line-height: 1.6;
      }

      :deep(a) {
        color: $accent;
        text-decoration: none;
        transition: all 0.2s ease;

        &:hover {
          color: lighten($accent, 10%);
          text-shadow: 0 0 10px rgba($accent, 0.3);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .terms-page {
    .nav {
      padding: 0 5%;

      .logo {
        width: 30%;
      }
    }

    .terms-container {
      padding: 20px 5%;

      .terms-content {
        padding: 30px 20px;
      }
    }
  }
}
</style>
